import { ISelection } from '../../../../../../Queries/EkonomiskAnalysInitQuery/EkonomiskAnalysInitQuery';
import EDRadioGroup from '../../../../../../../../../../../BaseComponents/RadioGroup/EDRadioGroup';
import { makeStyles } from 'tss-react/mui';

interface IProps {
  availableReports: ISelection[];
  kod: string;
  onChange: (kod: string) => void;
}

const useStyles = () =>
  makeStyles()({
    formControl: {
      marginTop: 0,
    },
  } as const);

/**
 * Komponent för att välja kodbehörighet
 */
const EkonomiskAnalysKodbehorighetSelection = (props: IProps) => {
  const { kod, onChange, availableReports } = props;
  const { ...rest } = useStyles();
  return (
    <>
      <EDRadioGroup
        label="Välj bland dina kodbehörigheter"
        value={kod}
        onChange={onChange}
        radioDefs={availableReports.map(x => ({
          value: x.id,
          label: x.name,
        }))}
        classes={rest}
      />
    </>
  );
};

export default EkonomiskAnalysKodbehorighetSelection;
